import { unstable_useBlocker as useBlocker } from 'react-router-dom'

import { Dialog } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

interface EnsureSaveDialogProps {
  isDirty: boolean
  onSave: () => Promise<void>
}

const EnsureSaveDialog = ({ isDirty, onSave }: EnsureSaveDialogProps) => {
  const blocker = useBlocker(isDirty)

  const handleSaveAndContinue = async () => {
    await onSave()
    setTimeout(() => blocker.proceed?.(), 500)
  }

  const handleCancel = () => {
    blocker.reset?.()
  }

  const handleContinueWithoutSaving = () => {
    blocker.proceed?.()
  }

  return (
    <Dialog
      open={blocker.state === 'blocked'}
      onClose={handleCancel}
      header={{
        type: 'critical',
        title: i18n.t('forms.alert_dialog.title'),
        description: '',
      }}
      actions={{
        primary: {
          label: i18n.t('forms.alert_dialog.save_and_continue'),
          onClick: handleSaveAndContinue,
        },
        secondary: {
          label: i18n.t('forms.alert_dialog.continue_without_saving'),
          onClick: handleContinueWithoutSaving,
        },
      }}
    />
  )
}

export default EnsureSaveDialog
